import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useThemeStore } from '@/store/theme';
import { useToastStore } from '@/store/toast';

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggle } = useThemeStore();
  const push = useToastStore((s) => s.push);

  const handle = () => {
    toggle();
    const next = theme === 'light' ? 'dark' : 'light';
    push(t(next === 'dark' ? 'toast.themeDark' : 'toast.themeLight'), 'info');
  };

  return (
    <button
      onClick={handle}
      className="btn btn-ghost rounded-DEFAULT p-2"
      title={t('theme.toggle')}
      aria-label={t('theme.toggle')}
    >
      {theme === 'light' ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
    </button>
  );
}
